export default __webpack_public_path__ + "static/media/32_TopRightSquares_Left.541d1032.mp4";